(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('training-record', {
            parent: 'training_menu',
            url: '/training-record?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingRecord.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training-record/training-records.html',
                    controller: 'TrainingRecordController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingRecord');
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingEventSignup');
                    $translatePartialLoader.addPart('trainingEvent');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('training-record-detail', {
            parent: 'training_menu',
            url: '/training-record/{id}',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingRecord.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training-record/training-record-detail.html',
                    controller: 'TrainingRecordDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingRecord');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrainingRecord', function($stateParams, TrainingRecord) {
                    return TrainingRecord.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'training-record',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('training-record-detail.edit', {
            parent: 'training-record-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-dialog.html',
                    controller: 'TrainingRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training-record.new', {
            parent: 'training-record',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-dialog.html',
                    controller: 'TrainingRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                signupDate: null,
                                examPassed: null,
                                traineeSignedDate: null,
                                id: null,
                                validToDate: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('training-record', null, { reload: 'training-record' });
                }, function() {
                    $state.go('training-record');
                });
            }]
        })
        .state('training-record.edit', {
            parent: 'training-record',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-dialog.html',
                    controller: 'TrainingRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-record', null, { reload: 'training-record' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training-record.delete', {
            parent: 'training-record',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-delete-dialog.html',
                    controller: 'TrainingRecordDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-record', null, { reload: 'training-record' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
